var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUpgrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "16px",
    viewBox: "0 0 15 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Onboarding",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "13-Contact-detail",
    transform: "translate(-371.000000, -11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(372.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-upgrade"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,15 C0,15 6.52173913,10.4347826 13.0434783,0.652173913 L13.0434783,2.60869565",
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 1.30434783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.7826087,11.7391304 C7.23782609,14.283913 3.70108696,11.9791304 1.71,13.6558696",
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 1.30434783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3913043,8.47826087 C12.3913043,8.47826087 11.7391304,9.7826087 9.13043478,9.7826087",
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 1.30434783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0434783,5.2173913 C13.0434783,6.53021739 11.7391304,6.52173983 11.7391304,6.52173983",
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 1.30434783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.956522, 0.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.299347826,12.9163043 C0.299347826,12.9163043 0,11.4319565 0,10.4217391 C0,3.03326087 8.17434783,2.87282609 10.5286957,0.315 C10.6865217,0.527608696 8.51413043,4.00304348 8.51413043,4.00304348 C6.2726087,7.32717391 4.49804348,8.89043478 2.05826087,11.253913 L0.299347826,12.9163043 Z"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpgrade);
export default __webpack_public_path__ + "static/media/icon-upgrade.c4ded55b27e8666a64086d1097849138.svg";
export { ForwardRef as ReactComponent };